import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const MessageBannerWrapper = styled.div`
  padding: ${Spacing.S8} 0;
`
